import { AfterViewInit, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '@ridango/core';
import { takeUntil } from 'rxjs/operators';
import { OpenTripPlannerService, OpenTripPlannerFacade, OtpUtil, RoutePatternStops } from '@ridango/components';
import { MapApiService } from '@ridango/widgets';
import { LatLng } from '@ridango/core';

@Component({
    templateUrl: './explore-schedule-on-stop-page.component.html'
})
export class ExploreScheduleOnStopPageComponent extends BaseComponent implements AfterViewInit {
    selectedOption: RoutePatternStops;
    data: RoutePatternStops[];

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private openTripPlannerService: OpenTripPlannerService,
        private openTripPlannerFacade: OpenTripPlannerFacade,
        private mapApi: MapApiService
    ) {
        super();
        const navigationState = this.router.getCurrentNavigation()?.extras?.state;
        if (navigationState) {
            this.selectedOption = navigationState.selectedOption;
            this.data = navigationState.data;
        }
    }

    ngAfterViewInit(): void {
        this.route.paramMap.pipe(takeUntil(this.componentDestroyed$)).subscribe((params) => {
            const patternId = params.get('patternId');
            const stopId = params.get('stopId');

            if (patternId && this.selectedOption) {
                this.openTripPlannerService
                    .getPatternGeometry(patternId)
                    .pipe(takeUntil(this.componentDestroyed$))
                    .subscribe((geometry) => {
                        this.openTripPlannerFacade.setExploreMapRoute({
                            polyline: geometry.points,
                            polylineColor: this.selectedOption.route.color,
                            stops: OtpUtil.transformStopsStopMarkers(this.selectedOption.stops)
                        });

                        if (stopId) {
                            this.openTripPlannerService
                                .getStop(stopId)
                                .pipe(takeUntil(this.componentDestroyed$))
                                .subscribe((stop) => {
                                    const latLng: LatLng = { lat: stop.lat, lng: stop.lon };
                                    this.mapApi.centerMapToCoordinates(latLng);
                                });
                        }
                    });
            }
        });
    }
}
